class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    this.touchStartTimestamp = 0;
    this.onPointerMove = this.onPointerMove.bind(this);

    this.addEventListener("pointerdown", this.onPointerDown.bind(this));
    this.addEventListener("touchstart", this.onTouchStart.bind(this), { passive: false });
    this.addEventListener("keydown", this.onKeyboardNavigation.bind(this));
  }

  connectedCallback() {
    this.animateInitialCursor();
  }

  onPointerDown(event) {
    if (event.target.tagName === "A") return;

    document.addEventListener("pointerup", this.onPointerUp.bind(this), { once: true });
    document.addEventListener("pointermove", this.onPointerMove);
    this.updateCursor(event);
  }

  onPointerMove(event) {
    this.updateCursor(event);
  }

  onTouchStart(event) {
    const cursor = this.querySelector(".before-after__cursor");
    if (cursor.contains(event.target)) {
      event.preventDefault();
      document.addEventListener("pointermove", this.onPointerMove);
    } else {
      this.touchStartTimestamp = event.timeStamp;
    }
  }

  onPointerUp(event) {
    document.removeEventListener("pointermove", this.onPointerMove);
    if (event.timeStamp - this.touchStartTimestamp <= 250) {
      this.updateCursor(event);
    }
  }

  onKeyboardNavigation(event) {
    const isVertical = this.hasAttribute("vertical");
    const key = event.code;
    const isValidKey = isVertical ? (key === "ArrowUp" || key === "ArrowDown") : (key === "ArrowLeft" || key === "ArrowRight");

    if (!event.target.classList.contains("before-after__cursor") || !isValidKey) return;

    event.preventDefault();

    let current = parseInt(this.style.getPropertyValue("--before-after-cursor-position")) || 
                  parseInt(getComputedStyle(this).getPropertyValue("--before-after-initial-cursor-position")) || 50;

    if (isVertical) {
      current += key === "ArrowUp" ? -1 : 1;
    } else {
      current += key === "ArrowLeft" ? -1 : 1;
    }

    this.style.setProperty("--before-after-cursor-position", Math.min(Math.max(current, 0), 100) + "%");
  }

  updateCursor(event) {
    const rect = this.getBoundingClientRect();
    let percent = 0;

    if (this.hasAttribute("vertical")) {
      percent = ((event.clientY - rect.top) / this.clientHeight) * 100;
    } else {
      percent = ((event.clientX - rect.left) / this.clientWidth) * 100;
      if (document.dir === "rtl") {
        percent = 100 - percent;
      }
    }

    this.style.setProperty("--before-after-cursor-position", Math.min(Math.max(percent, 0), 100) + "%");
  }

  animateInitialCursor() {
    const start = performance.now();
    const duration = 600;
    const easing = t => (--t) * t * t + 1; // easeOutCubic

    const animate = now => {
      const timeFraction = Math.min((now - start) / duration, 1);
      const progress = easing(timeFraction);
      const initial = getComputedStyle(this).getPropertyValue("--before-after-initial-cursor-position").trim();
      this.style.setProperty("--before-after-cursor-position", `calc(${initial} * ${progress})`);
      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }
}

if (!window.customElements.get("before-after")) {
  window.customElements.define("before-after", BeforeAfter);
}
